import { useSelector } from 'react-redux';
import { DEFAULT_APP_MODE, SessionType } from '@shared';
import { selectFeatureFlags, selectSession } from '@/model/selectors';

export function useAppMode(): AppMode {
  return useSelector(selectSession).appMode ?? DEFAULT_APP_MODE;
}

/** The guided consumer flow runs only when the advisor has both the d2cMode flag and the d2c app mode. */
export function useIsConsumerFlowEnabled(): boolean {
  const appMode = useAppMode();
  const isD2CFlagOn = !!useSelector(selectFeatureFlags).d2cMode;
  return appMode === 'd2c' && isD2CFlagOn;
}

/** The consumer themself is signed in, as opposed to their advisor or a wizard viewing the plan. */
export function useIsConsumerSession(): boolean {
  const isClient = useSelector(selectSession).sessionType === SessionType.client;
  return useIsConsumerFlowEnabled() && isClient;
}
